import gsap from "gsap";
import {num_word, numToPrice} from "./functions.js";

export default class {
    constructor() {
        this.block = document.querySelector('.st-cetering');

        if(!this.block) return;

        this.inputGuests  =  this.block.querySelector('[name="guests"]');
        this.inputPrice   =  this.block.querySelector('[name="price"]');
        this.inputKitchen =  this.block.querySelector('[name="kitchen"]');


        this.btnCalc  =  this.block.querySelector('.js-calc');
        this.btnOrder =  this.block.querySelector('.js-order');

        this.resultBlock = this.block.querySelector('.st-cetering__result');

        this.resultBlock.style.opacity = 0;
        this.resultPrice  =  this.block.querySelector('.price');
        this.resultGuests =  this.block.querySelector('.guests');

        this.formResultBlock = document.querySelector('#viewModalCetaring');

        this.formResultKitchen = this.formResultBlock.querySelector('[name="kitchen"]');
        this.formResultPrice = this.formResultBlock.querySelector('[name="price"]');
        this.formResultGuests = this.formResultBlock.querySelector('[name="guests"]');

        this.formValueKitchen = this.formResultBlock.querySelector('.js-value-kitchen');
        this.formValuePrice = this.formResultBlock.querySelector('.js-value-price');
        this.formValueGuests = this.formResultBlock.querySelector('.js-value-guests');

        this.btnCalc.addEventListener('click', () => {

            this.resultPrice.innerHTML = numToPrice(this.inputPrice.value * this.inputGuests.value)
            this.resultGuests.innerHTML = this.inputGuests.value + " " + num_word(this.inputGuests.value, ['гость', 'гостя', 'гостей'])

            this.formResultKitchen.value = this.inputKitchen.value;
            this.formResultPrice.value = this.inputPrice.value;
            this.formResultGuests.value = this.inputGuests.value;

            this.formValueKitchen.innerHTML = this.inputKitchen.value;
            this.formValuePrice.innerHTML = this.inputPrice.value;
            this.formValueGuests.innerHTML = this.inputGuests.value;


            gsap.to(this.resultBlock, {
                opacity:1,
                height: "100%"
            });

        });

        this.btnOrder.addEventListener('click', () => {
            this.modal.open("#viewModalCetaring");
        });
    }

    setModal(modal) {
        this.modal = modal;
    }
}